const env = {};

// The API is served from the same origin as the SPA. During `npm start` the dev server
// forwards /api calls to the backend (see "proxy" in package.json).
// Set REACT_APP_API_URL to point the UI at a different API instead.
env.baseUrl = process.env.REACT_APP_API_URL || '/api';

export default env;
